<div id="root" class="vh-100 d-flex flex-column">
    <div class="text-light bg-dark" data-bs-theme="dark">
        <div class="container">
            <nav class="navbar navbar-dark navbar-expand-lg">
                <!-- Left -->
                <img src="/images/logo.png" class="me-2" style="height: 40px;">

                <button id="btn-theme-mobile" class="btn ms-auto me-2 d-lg-none fs-4" aria-label="Toggle theme">
                    <i class="bi bi-sun-fill"></i>
                </button>

                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarContent">
                    <!-- Center -->
                    <div class="navbar-nav tabs">
                        <button id="btn-table-tab" class="nav-link d-none">Score Tables</button>
                        <button id="btn-elimination-tab" class="nav-link d-none">Elimination</button>
                        <button id="btn-wheel-tab" class="nav-link d-none">Wheel</button>
                        <button id="btn-settings-tab active" class="nav-link">Settings</button>
                    </div>

                    <!-- Right -->
                    <div class="d-flex flex-column flex-lg-row align-items-center justify-content-center justify-content-lg-end gap-3 ms-lg-auto mt-3 mt-lg-0">
                        <button id="btn-theme-desktop" class="btn d-none d-md-flex fs-4"
                            aria-label="Toggle theme">
                            <i class="bi bi-sun-fill"></i>
                        </button>
                        <div class="logout d-flex flex-row gap-2">
                            <span class="d-none d-md-flex align-items-center">
                                <span>Logged in as <strong class="text-success username">user</strong>.</span>
                            </span>
                            <button id="btn-logout" class="btn btn-danger">Log Out</button>
                        </div>
                        <div class="login ms-auto d-flex">
                            <button id="btn-login" class="btn btn-primary">Log In</button>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    </div>
    <div id="main-column" class="container py-2 d-flex flex-column flex-grow-1">
        <div id="tab-root" class="d-flex flex-column flex-grow-1">
        </div>
    </div>
</div>